// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.club-license-card {
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
  padding: 24px;
  margin-bottom: 24px;
  font-family: inherit;
}

.club-license-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
  padding-bottom: 14px;
  border-bottom: 1px solid #edf2f7;
}

.club-license-title-group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.club-license-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: #1a202c;
  margin: 0;
}

.club-license-badge {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.badge-base {
  background-color: #ebf8ff;
  color: #2b6cb0;
  border: 1px solid #bee3f8;
}

.badge-plus {
  background-color: #f0fdf4;
  color: #15803d;
  border: 1px solid #bbf7d0;
}

.badge-pro {
  background-color: #faf5ff;
  color: #6b21a8;
  border: 1px solid #e9d5ff;
}

.club-license-desc {
  color: #4a5568;
  font-size: 0.88rem;
  line-height: 1.5;
  margin-bottom: 20px;
}

.license-tier-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}

.license-tier-option {
  position: relative;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  padding: 16px;
  cursor: pointer;
  background-color: #ffffff;
  transition: all 0.2s ease-in-out;
  display: flex;
  flex-direction: column;
}

.license-tier-option:hover {
  border-color: #cbd5e1;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
}

.license-tier-option.active {
  border-color: #3b82f6;
  background-color: #eff6ff;
  box-shadow: 0 4px 14px rgba(59, 130, 246, 0.12);
}

.license-tier-option.active.tier-pro {
  border-color: #9333ea;
  background-color: #faf5ff;
  box-shadow: 0 4px 14px rgba(147, 51, 234, 0.12);
}

.license-tier-option.active.tier-plus {
  border-color: #10b981;
  background-color: #ecfdf5;
  box-shadow: 0 4px 14px rgba(16, 185, 129, 0.12);
}

.tier-top-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.tier-name {
  font-size: 1.05rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
}

.tier-quota-pill {
  font-size: 0.72rem;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 6px;
  background: #e2e8f0;
  color: #475569;
}

.tier-summary {
  font-size: 0.82rem;
  color: #64748b;
  margin-bottom: 12px;
  flex-grow: 1;
}

.tier-feature-bullets {
  list-style: none;
  padding: 0;
  margin: 0;
  font-size: 0.8rem;
  color: #334155;
}

.tier-feature-bullets li {
  margin-bottom: 6px;
  display: flex;
  align-items: flex-start;
  gap: 6px;
}

.tier-bullet-check {
  color: #10b981;
  font-weight: 700;
}

.tier-bullet-highlight {
  font-weight: 600;
  color: #0f172a;
}

.addon-card {
  background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);
  border: 1px solid #fde68a;
  border-radius: 10px;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}

.addon-info {
  display: flex;
  align-items: center;
  gap: 14px;
}

.addon-icon {
  font-size: 1.6rem;
  color: #d97706;
}

.addon-text-title {
  font-weight: 700;
  color: #92400e;
  font-size: 0.96rem;
  margin: 0 0 4px 0;
}

.addon-text-desc {
  font-size: 0.82rem;
  color: #78350f;
  margin: 0;
}

.switch-toggle-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
}

.switch-track {
  width: 50px;
  height: 26px;
  background-color: #cbd5e1;
  border-radius: 9999px;
  position: relative;
  transition: background-color 0.2s;
}

.switch-track.checked {
  background-color: #10b981;
}

.switch-thumb {
  width: 20px;
  height: 20px;
  background-color: #ffffff;
  border-radius: 50%;
  position: absolute;
  top: 3px;
  left: 3px;
  transition: transform 0.2s;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.switch-track.checked .switch-thumb {
  transform: translateX(24px);
}

.role-capabilities-tabs {
  background-color: #f8fafc;
  border-radius: 8px;
  padding: 16px;
  border: 1px solid #e2e8f0;
}

.role-tabs-header {
  display: flex;
  gap: 12px;
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 10px;
  margin-bottom: 14px;
}

.role-tab-btn {
  background: none;
  border: none;
  padding: 6px 14px;
  font-size: 0.85rem;
  font-weight: 600;
  border-radius: 6px;
  cursor: pointer;
  color: #64748b;
  transition: all 0.15s;
}

.role-tab-btn.active {
  background-color: #ffffff;
  color: #0f172a;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.features-chip-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.feature-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 0.76rem;
  font-weight: 500;
}

.feature-chip.enabled {
  background-color: #dbeafe;
  color: #1e40af;
  border: 1px solid #bfdbfe;
}

.feature-chip.disabled {
  background-color: #f1f5f9;
  color: #94a3b8;
  border: 1px dashed #cbd5e1;
  text-decoration: line-through;
}
`, "",{"version":3,"sources":["webpack://./src/components/superadmin/ClubLicenseSettingsCard.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,gCAAgC;EAChC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,0BAA0B;EAC1B,6BAA6B;AAC/B","sourcesContent":[".club-license-card {\n  background: #ffffff;\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);\n  padding: 24px;\n  margin-bottom: 24px;\n  font-family: inherit;\n}\n\n.club-license-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 18px;\n  padding-bottom: 14px;\n  border-bottom: 1px solid #edf2f7;\n}\n\n.club-license-title-group {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.club-license-title {\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: #1a202c;\n  margin: 0;\n}\n\n.club-license-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 10px;\n  border-radius: 9999px;\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.badge-base {\n  background-color: #ebf8ff;\n  color: #2b6cb0;\n  border: 1px solid #bee3f8;\n}\n\n.badge-plus {\n  background-color: #f0fdf4;\n  color: #15803d;\n  border: 1px solid #bbf7d0;\n}\n\n.badge-pro {\n  background-color: #faf5ff;\n  color: #6b21a8;\n  border: 1px solid #e9d5ff;\n}\n\n.club-license-desc {\n  color: #4a5568;\n  font-size: 0.88rem;\n  line-height: 1.5;\n  margin-bottom: 20px;\n}\n\n.license-tier-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.license-tier-option {\n  position: relative;\n  border: 2px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 16px;\n  cursor: pointer;\n  background-color: #ffffff;\n  transition: all 0.2s ease-in-out;\n  display: flex;\n  flex-direction: column;\n}\n\n.license-tier-option:hover {\n  border-color: #cbd5e1;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);\n}\n\n.license-tier-option.active {\n  border-color: #3b82f6;\n  background-color: #eff6ff;\n  box-shadow: 0 4px 14px rgba(59, 130, 246, 0.12);\n}\n\n.license-tier-option.active.tier-pro {\n  border-color: #9333ea;\n  background-color: #faf5ff;\n  box-shadow: 0 4px 14px rgba(147, 51, 234, 0.12);\n}\n\n.license-tier-option.active.tier-plus {\n  border-color: #10b981;\n  background-color: #ecfdf5;\n  box-shadow: 0 4px 14px rgba(16, 185, 129, 0.12);\n}\n\n.tier-top-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.tier-name {\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: #1e293b;\n  margin: 0;\n}\n\n.tier-quota-pill {\n  font-size: 0.72rem;\n  font-weight: 600;\n  padding: 2px 8px;\n  border-radius: 6px;\n  background: #e2e8f0;\n  color: #475569;\n}\n\n.tier-summary {\n  font-size: 0.82rem;\n  color: #64748b;\n  margin-bottom: 12px;\n  flex-grow: 1;\n}\n\n.tier-feature-bullets {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  font-size: 0.8rem;\n  color: #334155;\n}\n\n.tier-feature-bullets li {\n  margin-bottom: 6px;\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n}\n\n.tier-bullet-check {\n  color: #10b981;\n  font-weight: 700;\n}\n\n.tier-bullet-highlight {\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.addon-card {\n  background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);\n  border: 1px solid #fde68a;\n  border-radius: 10px;\n  padding: 16px 20px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 24px;\n}\n\n.addon-info {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n\n.addon-icon {\n  font-size: 1.6rem;\n  color: #d97706;\n}\n\n.addon-text-title {\n  font-weight: 700;\n  color: #92400e;\n  font-size: 0.96rem;\n  margin: 0 0 4px 0;\n}\n\n.addon-text-desc {\n  font-size: 0.82rem;\n  color: #78350f;\n  margin: 0;\n}\n\n.switch-toggle-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n}\n\n.switch-track {\n  width: 50px;\n  height: 26px;\n  background-color: #cbd5e1;\n  border-radius: 9999px;\n  position: relative;\n  transition: background-color 0.2s;\n}\n\n.switch-track.checked {\n  background-color: #10b981;\n}\n\n.switch-thumb {\n  width: 20px;\n  height: 20px;\n  background-color: #ffffff;\n  border-radius: 50%;\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  transition: transform 0.2s;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n.switch-track.checked .switch-thumb {\n  transform: translateX(24px);\n}\n\n.role-capabilities-tabs {\n  background-color: #f8fafc;\n  border-radius: 8px;\n  padding: 16px;\n  border: 1px solid #e2e8f0;\n}\n\n.role-tabs-header {\n  display: flex;\n  gap: 12px;\n  border-bottom: 1px solid #e2e8f0;\n  padding-bottom: 10px;\n  margin-bottom: 14px;\n}\n\n.role-tab-btn {\n  background: none;\n  border: none;\n  padding: 6px 14px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  border-radius: 6px;\n  cursor: pointer;\n  color: #64748b;\n  transition: all 0.15s;\n}\n\n.role-tab-btn.active {\n  background-color: #ffffff;\n  color: #0f172a;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n\n.features-chip-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.feature-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  border-radius: 6px;\n  font-size: 0.76rem;\n  font-weight: 500;\n}\n\n.feature-chip.enabled {\n  background-color: #dbeafe;\n  color: #1e40af;\n  border: 1px solid #bfdbfe;\n}\n\n.feature-chip.disabled {\n  background-color: #f1f5f9;\n  color: #94a3b8;\n  border: 1px dashed #cbd5e1;\n  text-decoration: line-through;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
